import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
    <div class="layout-footer">
      <div class="layout-footer-left">
        <span>{{ currentYear }} Front Office Method</span>
      </div>
      <div class="layout-footer-right">
      </div>
    </div>
  `
})
export class AppFooterComponent {
  currentYear: number = new Date().getFullYear();
}